import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-software-registration',
  templateUrl: './software-registration.component.html',
  styleUrls: ['./software-registration.component.css']
})
export class SoftwareRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
